/**
 * append banner module to some dom
 * @requires  banner.mod  common_function.js  jQuery
 */
import Vue from 'vue/dist/vue.min'
import objectHelper from '../../common/common_script/helper/object';
import Link from '../../common/prefixName';
import bannerModuleContent from '../../html/content_module/banner.mod';

var bannerHelper = {
    element : $(bannerModuleContent)[0],
    apiUrl: Link.prefix.realmName + "/portal/advertis/getAdvertisByType",
    control : null,

    init : function (){
        var me = this;
        me.control = new Vue({
            el : '#' + me.element.id,
            data : {
                ad : null,
                showHeader : true,
                showFooter : true
            },
            methods : {
                openUrl: function(id, url){

                    $.ajax({
                        url: Link.prefix.realmName + "/portal/advertis/click",
                        data: {
                            id: id
                        },
                        success: function (result) {},
                        error: function (result) {
                        },
                        complete: function() {
                            //set Session Key
                            setSessionData('ad_sessino_key',id);
                            location.href=url;
                        }
                    });
                },
            }
        });
        return me.control;
    },

    loadData : function (options, params) {

        if (!this.control)
        {
            addConsoleLog('controller not init.');
            return;
        }

        typeof(options) == 'undefined' ? options = {} : null;
        typeof(params)  == 'undefined' ? params = {} : null;

        var typeEnum = options.typeEnum || '';
        var me = this;
        $.ajax({
            url: me.apiUrl,
            data: objectHelper.merge(params, {
                typeEnum: typeEnum,
                limit : 1
            }),
            success: function (result) {
                if (result.errorCode)
                {
                    addConsoleLog('[error] ' + result.msg);
                    return;
                }

                if (!me.control)
                {
                    addConsoleLog('controller not init.');
                    return;
                }
                if (result.data && result.data.length)
                {
                    me.control.ad = result.data[0];
                    log('ad: ' + JSON.stringify(result.data[0]));
                }
                else
                {
                    log('no ad.');
                }
                // result.data.length ? me.control.ad = result.data[0] : null;
            },
            error: function (result) {
                dialog.msg(result.msg)
            }
        }); // end ajax()

    }
};

export default bannerHelper;



/** WEBPACK FOOTER **
 ** D:/app project/shixun-web/src/shixun-mobile/js/content_module/banner.js
 **/